import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import ReactImageMagnify from 'react-image-magnify';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {  useSearchParams } from 'react-router-dom';
import { getProductColorImage } from '../services/Product-service';
import Loader from "../components/Loader";
const SingleProductImg = ({productDetails,scrollToSimilarSection}) => {
  
const settings = {
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
};

  const [images, setImages] = useState(productDetails || []);
  const [image, setImage] = useState(productDetails?.product_thumbail || []);
  const [largeimage, setlargeImage] = useState('');
  const [queryParameters, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(false);
    // Update images state when productDetails change
    if (productDetails) {
      setImages(productDetails);
    }
    if(productDetails?.length>0){
      setlargeImage(productDetails[0]?.image_name);
    }
    
  }, [productDetails]);
 
  const [activeThumbnailIndex, setActiveThumbnailIndex] = useState(0);
  const [showHiResModal, setShowHiResModal] = useState(false);
  const [currentHiResIndex, setCurrentHiResIndex] = useState(0);
  const [mobileViewerIndex, setMobileViewerIndex] = useState(null);
  const [pinchScale, setPinchScale] = useState(1);
  const [showZoomHint, setShowZoomHint] = useState(true);
  const mobileImagePressStart = useRef(null);
  const mobileViewerScrollerRef = useRef(null);
  const pinchStateRef = useRef(null);
  const pinchScaleRef = useRef(1);
  const activeViewerIndexRef = useRef(0);
  const mobileImageCount = Math.min(Array.isArray(images) ? images.length : 0, 5);
  const mobileViewerSlides = (Array.isArray(images) ? images : []).slice(0, 5);

  const handleThumbnailClick = (index,image_url) => {
    setActiveThumbnailIndex(index);
    setlargeImage(image_url);
  };

  const handleViewHiResClick = () => {
    setCurrentHiResIndex(activeThumbnailIndex);
    setShowHiResModal(true);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  };

  const closeHiResModal = () => {
    setShowHiResModal(false);
    // Restore body scroll when modal is closed
    document.body.style.overflow = 'unset';
  };

  const handleHiResThumbnailClick = (index) => {
    setCurrentHiResIndex(index);
  };

  const openMobileViewer = (index) => {
    activeViewerIndexRef.current = index;
    pinchScaleRef.current = 1;
    setPinchScale(1);
    setMobileViewerIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const closeMobileViewer = () => {
    setMobileViewerIndex(null);
    pinchScaleRef.current = 1;
    setPinchScale(1);
    document.body.style.overflow = 'unset';
  };

  const dismissZoomHint = () => {
    setShowZoomHint(false);
    try {
      sessionStorage.setItem('orat-mobile-zoom-hint', '1');
    } catch (error) {
      // Ignore storage failures; the hint still closes for this view.
    }
  };

  const handleMobileImagePointerDown = (event) => {
    mobileImagePressStart.current = { x: event.clientX, y: event.clientY };
  };

  const handleMobileImageClick = (index, event) => {
    const start = mobileImagePressStart.current;
    mobileImagePressStart.current = null;
    if (start) {
      const movedX = Math.abs(event.clientX - start.x);
      const movedY = Math.abs(event.clientY - start.y);
      if (movedX > 10 || movedY > 10) return;
    }
    openMobileViewer(index);
  };

  const handleViewerScroll = () => {
    const scroller = mobileViewerScrollerRef.current;
    if (!scroller || pinchStateRef.current) return;
    const width = scroller.clientWidth || 1;
    const next = Math.round(scroller.scrollLeft / width);
    if (next < 0 || next >= mobileImageCount || next === activeViewerIndexRef.current) return;
    activeViewerIndexRef.current = next;
    pinchScaleRef.current = 1;
    setPinchScale(1);
    setMobileViewerIndex(next);
  };

  // Close modal on ESC key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && showHiResModal) {
        setShowHiResModal(false);
        document.body.style.overflow = 'unset';
      }
    };

    if (showHiResModal) {
      document.addEventListener('keydown', handleEscKey);
      return () => {
        document.removeEventListener('keydown', handleEscKey);
      };
    }
  }, [showHiResModal]);

  useEffect(() => {
    if (mobileViewerIndex === null) return undefined;

    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setMobileViewerIndex(null);
        document.body.style.overflow = 'unset';
      }
    };

    const closeOnDesktop = () => {
      if (window.matchMedia('(min-width: 768px)').matches) {
        setMobileViewerIndex(null);
        document.body.style.overflow = 'unset';
      }
    };

    const desktopMedia = window.matchMedia('(min-width: 768px)');
    document.addEventListener('keydown', handleEscKey);
    desktopMedia.addEventListener('change', closeOnDesktop);

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      desktopMedia.removeEventListener('change', closeOnDesktop);
    };
  }, [mobileViewerIndex]);

  useEffect(() => {
    try {
      if (sessionStorage.getItem('orat-mobile-zoom-hint') === '1') {
        setShowZoomHint(false);
      }
    } catch (error) {
      // Keep the hint visible if storage cannot be read.
    }
  }, []);

  useEffect(() => {
    if (mobileViewerIndex === null) return undefined;
    const scroller = mobileViewerScrollerRef.current;
    if (!scroller || scroller.dataset.aligned === '1') return undefined;

    const alignToOpenedImage = () => {
      const width = scroller.clientWidth || window.innerWidth;
      if (!width) return;
      scroller.scrollLeft = activeViewerIndexRef.current * width;
      scroller.dataset.aligned = '1';
    };

    alignToOpenedImage();
    const frame = requestAnimationFrame(alignToOpenedImage);
    return () => cancelAnimationFrame(frame);
  }, [mobileViewerIndex]);

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    if (mobileViewerIndex === null) return undefined;
    const scroller = mobileViewerScrollerRef.current;
    if (!scroller) return undefined;

    const touchDistance = (touches) => {
      const [first, second] = touches;
      return Math.hypot(first.clientX - second.clientX, first.clientY - second.clientY);
    };

    const handleTouchStart = (event) => {
      if (event.touches.length !== 2) return;
      pinchStateRef.current = {
        startDist: touchDistance(event.touches),
        startScale: pinchScaleRef.current,
      };
    };

    const handleTouchMove = (event) => {
      if (event.touches.length !== 2 || !pinchStateRef.current?.startDist) return;
      event.preventDefault();
      const nextScale = pinchStateRef.current.startScale * (touchDistance(event.touches) / pinchStateRef.current.startDist);
      const clamped = Math.min(4, Math.max(1, nextScale));
      pinchScaleRef.current = clamped;
      setPinchScale(clamped);
    };

    const handleTouchEnd = (event) => {
      if (event.touches.length >= 2) return;
      pinchStateRef.current = null;
      if (pinchScaleRef.current < 1.05) {
        pinchScaleRef.current = 1;
        setPinchScale(1);
      }
    };

    scroller.addEventListener('touchstart', handleTouchStart, { passive: true });
    scroller.addEventListener('touchmove', handleTouchMove, { passive: false });
    scroller.addEventListener('touchend', handleTouchEnd);
    scroller.addEventListener('touchcancel', handleTouchEnd);

    return () => {
      scroller.removeEventListener('touchstart', handleTouchStart);
      scroller.removeEventListener('touchmove', handleTouchMove);
      scroller.removeEventListener('touchend', handleTouchEnd);
      scroller.removeEventListener('touchcancel', handleTouchEnd);
    };
  }, [mobileViewerIndex !== null]);
  
  
  
   useEffect(() => {
    
    async function getProductColorImagesList (){
      if (queryParameters.has('coolorvar')) {
      setLoading(true);
      if (queryParameters.has('coolorvar')) {
      const productDetails = {
        var_id: queryParameters.get('coolorvar')
    }
    getProductColorImage(productDetails).then((data) => {
      setLoading(false);
        
        if(data?.data?.length>0){
          setImages(data?.data);
          setlargeImage(data?.data[0]?.image_name);
        }else{
          setImages([]);
          setlargeImage('');
        }
        }
  
        ).catch((error) => {
  
        })
      }
    }
    }
    getProductColorImagesList();
       }, [queryParameters]);
  
  
  

  return (
    loading ? (
      <div className="flex xs5 prel">
      <Loader />
      </div>
    ) : (
    <div className="flex xs5 prel">
      <div className="layout align-start ProductImageSlider">
        <div className="ThumbnailImages">
          {images.map((data, index) => (
             index <=4 &&(
            <div
              key={index}
              className={index === activeThumbnailIndex ? 'active' : ''}
              onClick={() => handleThumbnailClick(index,data.image_name)}
            >
              <div className="dynamicImgContainer prel layout row align-center justify-center">
                <img src={data?.image_name} alt="logo" style={{ padding: '0px' }} />
              </div>
            </div>
             )
          ))}
          <button 
            className="ViewHiResBtn" 
            onClick={handleViewHiResClick}
            type="button"
          >
            <img 
              src="https://img.perniaspopupshop.com/ppus-assets/icons/icon-zoom29_03_23.svg" 
              alt="Zoom Icon" 
              className="ViewHiResIcon"
            />
            VIEW HI-RES IMAGES
          </button>
        </div>
        <div className="SelectedImage animated-background prel">

      {images ? (
              <ReactImageMagnify
              className='test_mag'
                {...{
                  smallImage: {
                    alt: 'Product thumbnail',
                    isFluidWidth: true,
                    src: largeimage,
                  },
                  largeImage: {
                    src: largeimage, // Use the same image for large and small for simplicity
                    width: 1200, // Adjust dimensions as needed
                    height: 1800, // Adjust dimensions as needed
                  },
                  enlargedImageContainerDimensions: {
                    width: '180%',
                    height: '100%',
                  },
                  
                }}
                enlargedImageContainerClassName="magnified-image-overlay"
              />
            ) : (
              <p>Loading image...</p>
            )}

        </div>
      </div>
      <div className="ProductImageSlider_mobile">
        <Slider className="owl-theme"  {...settings}>
        {images.map((data, index) => (
          index <=4 &&(
          <div className="item"  key={index}>
            <div className="CarouselSection product">
              <div className="prel Gutter">
                 <div className="layout justify-center m-t-15">
                                            <button
                                                type="button"
                                                className="view_sim"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    scrollToSimilarSection();
                                                }}
                                            >
                                                VIEW SIMILAR
                                            </button>
                                        </div>
                <button
                  type="button"
                  className="MobileProductImageBtn"
                  onPointerDown={handleMobileImagePointerDown}
                  onClick={(event) => handleMobileImageClick(index, event)}
                >
                  <div
                    className="DynamicHeightLoaderWrapper"
                    style={{ paddingTop: '130%', overflow: 'hidden' }}
                  >
                    <div
                      className="DynamicHeightLoader layout row align-center justify-center"
                      style={{ paddingTop: '22%' }}
                    >
                      <img
                        src={data?.image_name}
                        alt="Product"
                        className="img-resp DynamicHeightLoaderImage"
                        style={{ padding: '0px', bottom: 'inherit' }}
                      />
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          )
         ))}
        </Slider>
      </div>

      {mobileViewerIndex !== null && mobileViewerSlides[mobileViewerIndex]?.image_name && createPortal(
        <div className="MobileImageViewer" role="dialog" aria-modal="true" aria-label="Product images">
          <button
            type="button"
            className="MobileImageViewerClose"
            onClick={closeMobileViewer}
            aria-label="Close product images"
          >
            <img
              src="https://img.perniaspopupshop.com/pwa-assets/icons/cross-white.svg"
              alt=""
            />
          </button>
          <div
            className="MobileImageViewerScroller"
            ref={mobileViewerScrollerRef}
            onScroll={handleViewerScroll}
          >
            {mobileViewerSlides.map((data, index) => (
              <div className="MobileImageViewerSlide" key={index}>
                {data?.image_name && (
                  <img
                    src={data.image_name}
                    alt="Product"
                    className="MobileImageViewerImg"
                    draggable="false"
                    style={{ transform: `scale(${index === mobileViewerIndex ? pinchScale : 1})` }}
                  />
                )}
              </div>
            ))}
          </div>
          {showZoomHint && (
            <aside className="MobileImageViewerHint">
              <div className="MobileImageViewerHintHeader">
                <h3>A closer look</h3>
                <button type="button" onClick={dismissZoomHint} aria-label="Dismiss zoom help">
                  <img
                    src="https://img.perniaspopupshop.com/pwa-assets/icons/cross-white.svg"
                    alt=""
                  />
                </button>
              </div>
              <p>
                <img src="https://img.perniaspopupshop.com/ppus-assets/icons/revisedicon-zoom-in12_09_23.svg" alt="" />
                Spread two fingers to zoom in
              </p>
              <p>
                <img src="https://img.perniaspopupshop.com/ppus-assets/icons/revisedicon-zoom-out12_09_23.svg" alt="" />
                Pinch to zoom out
              </p>
              <button type="button" className="MobileImageViewerHintGotIt" onClick={dismissZoomHint}>
                Got it
              </button>
            </aside>
          )}
        </div>,
        document.body
      )}
      
      {/* Hi-Res Images Modal */}
      {showHiResModal && (
        <div className="HiResModalOverlay" onClick={closeHiResModal}>
          <div className="HiResModalContent" onClick={(e) => e.stopPropagation()}>
            <button className="HiResModalClose" onClick={closeHiResModal}>
              <img 
                src="https://img.perniaspopupshop.com/ppus-assets/icons/cross-black.svg" 
                alt="Close" 
                style={{ width: '26px', height: '26px' }}
              />
            </button>
            <div className="HiResModalMain">
              <div className="HiResModalThumbnails">
                {images && images.length > 0 ? (
                  images.map((data, index) => (
                    index <= 4 && data?.image_name && (
                      <div
                        key={index}
                        className={`HiResThumbnail ${index === currentHiResIndex ? 'active' : ''}`}
                        onClick={() => handleHiResThumbnailClick(index)}
                      >
                        <img src={data.image_name} alt={`Thumbnail ${index + 1}`} />
                      </div>
                    )
                  ))
                ) : null}
              </div>
              <div className="HiResModalMainImage">
                {images && images[currentHiResIndex]?.image_name ? (
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: 'Product thumbnail',
                        isFluidWidth: true,
                        src: images[currentHiResIndex].image_name,
                      },
                      largeImage: {
                        src: images[currentHiResIndex].image_name,
                        width: 1200,
                        height: 1800,
                      },
                      enlargedImageContainerDimensions: {
                        width: '100%',
                        height: '100%',
                      },
                      enlargedImagePosition: 'over',
                      isHintEnabled: false,
                    }}
                    enlargedImageContainerClassName="magnified-image-overlay-modal"
                  />
                ) : (
                  <img 
                    src={largeimage || images[0]?.image_name || ''} 
                    alt="Hi-Res Product" 
                    className="HiResMainImg"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    )
  );
};

export default SingleProductImg;
